import { db } from '@/core/db/dexie'

/**
 * Cache offline da parte diária (tabela `cache_parte_diaria`). Guarda as
 * últimas respostas que dependem de chefe/MVE/data, para o operador conseguir
 * lançar sem sinal. Tudo é revalidado pelo servidor no envio.
 *
 * Chaves: `mves:<YYYY-MM>`, `contexto:<mveId>:<dt>`, `obras`,
 * `servicos:<mveId>:<obraId>`, `equipes:<obraId>`.
 */
export async function lerCache<T>(key: string): Promise<{ value: T; fetchedAt: number } | null> {
  try {
    const row = await db.cache_parte_diaria.get(key)
    return row ? { value: row.value as T, fetchedAt: row.fetchedAt } : null
  } catch {
    return null
  }
}

export async function gravarCache(key: string, value: unknown): Promise<void> {
  try {
    await db.cache_parte_diaria.put({ key, value, fetchedAt: Date.now() })
  } catch (e) {
    console.warn('[parteDiariaCache] falha ao gravar', key, e)
  }
}
